import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function VegetableJambalaya() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Vegetable Jambalaya</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>
        120g/4½oz dried kidney beans, soaked overnight or 400g tin kidney beans,
        drained <br></br>
        olive oil, for frying<br></br>1 onion, finely chopped<br></br>2 garlic
        cloves, crushed<br></br>2 tsp smoked paprika<br></br>1 tsp dried oregano
        <br></br>1 tsp dried thyme<br></br>1 tsp fennel seeds<br></br>
        150g/5½oz brown basmati rice<br></br>1 bay leaf<br></br>
        400g tin chopped tomatoes<br></br>2 vegetable stock cubes, crumbled
        <br></br>
        750ml/26fl oz boiling water<br></br>
        500g/1lb 2oz mixed frozen vegetables<br></br>
      </Typography>

      <Typography>
        If you’re using dried kidney beans, drain the soaked beans in a
        colander, rinse thoroughly, then tip into a saucepan and cover with
        plenty of fresh cold water. Bring to the boil and cook at a rapid boil
        for 10 minutes, then reduce the heat and simmer gently for 1-2 hours,
        until soft. Drain, then set aside to cool.<br></br>
        Heat a splash of oil in a wide casserole over a medium-low heat and fry
        the onion and garlic gently for 5 minutes until soft. Add the smoked
        paprika, herbs and fennel seeds, fry for 30 seconds more, then stir in
        the rice.<br></br>
        Add the bay leaf, cooked (or tinned) beans, chopped tomatoes, stock
        cubes and boiling water and bring to a simmer. Cover with a lid and cook
        for 25 minutes.<br></br>
        Stir in the frozen vegetables, cover with a lid and remove from the
        heat. Leave to stand for 5 minutes or until the vegetables are warmed
        through.<br></br>
      </Typography>
    </Card>
  );
}
